import { createFileRoute } from "@tanstack/react-router";
import Privacy from "@/pages/Privacy";
import { pageHead } from "@/lib/seo";

export const Route = createFileRoute("/privacy")({
  head: () =>
    pageHead({
      path: "/privacy",
      title: "Politique de Confidentialité | CMO Partner",
      description:
        "Politique de confidentialité de CMO Partner : collecte des données, cookies, Google Analytics et droits RGPD.",
      enPath: null,
      crumbs: [["Politique de confidentialité", "/privacy"]],
    }),
  component: Privacy,
});
